export const LOCAL_STORAGE_CONNECTOR = "LOCAL_STORAGE_CONNECTOR";
export const AUTO_WALLET_RECONNECT = 'AUTO_WALLET_RECONNECT';